<template lang="pug">
  div.p-3.document-card
    div(v-for="field in cardData")
      span.mt-2.font-weight-bold
        | {{ field.label }}:
      div(v-html="processContent(field.values[0])" v-if="typeof field.values[0] == 'string' || Array.isArray(field.values[0])")
      div(v-else)
        ul
          li(v-for="value in field.values")
            span.mt-2.font-weight-bold
              | {{ value.label }}:
            div(v-html="processContent(value.values[0])")
</template>

<script>
import mixins from 'common/mixins'
import { marked } from 'marked'

export default {
  name: 'resumen-ia-vue',
  props: {
    cardData: { type: Array, default: () => [] }
  },
  mixins: [mixins.translate],
  methods: {
    processContent(text) {
      if (Array.isArray(text) && text.every(item => typeof item === 'string')) {
        const listItems = text.map(item => `<li>${marked.parse(item)}</li>`).join('')
        return `<ul>${listItems}</ul>`
      }
      if (typeof text !== 'string')
        return ''

      return marked.parse(text)
    }
  }
}
</script>
